module.exports = __webpack_public_path__ + "img/rm-lt-01.0bf642eb.webp";